import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'teekanne',
} as IModuleProps;
